import { useEffect, useState } from 'react';
import * as S from './WritingSummarizeWrittenText.styles';
import { Answer } from '../../Answer';
import useDebounce from '@app/hooks/useDebounce';
import CustomTextarea from '@app/components/exam/components/CustomTextarea';

interface Props {
  showAnswer: boolean;
  text: string;
  questionNumber: string;
  totalText: number;
  onAnswerChange?: (answer: string) => void;
  allowClipboardActions: boolean;
}

export const WritingSummarizeWrittenText: React.FC<Props> = ({
  showAnswer,
  text,
  questionNumber,
  onAnswerChange,
  allowClipboardActions,
}) => {
  const [answerContent, setAnswerContent] = useState<string>('');
  const debouncedAnswerContent = useDebounce(answerContent, 500);

  useEffect(() => {
    setAnswerContent('');
  }, [questionNumber]);

  useEffect(() => {
    if (onAnswerChange) onAnswerChange(debouncedAnswerContent);
  }, [debouncedAnswerContent, onAnswerChange]);

  return (
    <>
      <S.ContentQuestion>{text}</S.ContentQuestion>

      <CustomTextarea onChange={(value) => setAnswerContent(value)} allowClipboardActions={allowClipboardActions} />

      <div className="mt-5">
        {showAnswer && <Answer showAnswer={showAnswer} questionId={questionNumber} answer={debouncedAnswerContent} />}
      </div>
    </>
  );
};
